module.exports = __webpack_public_path__ + "static/media/hiw14.8d238bff.svg";